/* Human-led landing: accessible gift/self journey and a real product link. */
(() => {
 if(window.tlwkV6Loaded)return;window.tlwkV6Loaded=true;
 let observer;
 const init=()=>{
  document.querySelectorAll('[data-tlwk-journey]').forEach(root=>{
   if(root.dataset.ready)return;root.dataset.ready='true';
   const tabs=[...root.querySelectorAll('[data-journey-tab]')];
   const select=tab=>{tabs.forEach(button=>{const active=button===tab;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;});root.querySelectorAll('[data-journey-panel]').forEach(panel=>panel.hidden=panel.dataset.journeyPanel!==tab.dataset.journeyTab);};
   tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;select(tabs[next]);tabs[next].focus();});});
  });
  observer?.disconnect();const sticky=document.querySelector('[data-landing-sticky]'),cta=document.querySelector('.tlwk-hero-actions .tlwk-button');
  if(!sticky)return;
  // No-JS users still get a working anchor. Hide only while the hero CTA is visible.
  if(cta&&'IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{sticky.classList.toggle('is-hidden',entries[0].intersectionRatio>=0.9);},{threshold:[0,0.9]});observer.observe(cta);}
 };
 document.addEventListener('shopify:section:load',init);init();
})();
